/* angular:styles/component:css;f37013c80c0e4ed26184d602fc8a2ea2f603526a911e2d6a1fd0feefb9276828;/opt/atlassian/pipelines/agent/build/src/hgm-setup/src/module/components/entry/category-select-modal.ts */
:host-context(.ios) ion-toolbar ion-button ion-icon {
  margin-inline-end: 0;
}
ion-list {
  padding-bottom: 3rem;
}
ion-item {
  cursor: pointer;
}
ion-item[disabled] {
  opacity: 0.7;
}
ion-item.category-header {
  font-weight: 600;
  --color: var(--ion-color-step-600);
}
ion-item.category-header ion-icon.expander {
  margin-right: 0.7em;
}
:host-context(.md) ion-item.item-lines-none {
  --inner-padding-bottom: 1px;
}
:host-context(.ios) ion-item.item-lines-none {
  --inner-padding-bottom: 0.55px;
}
:host-context(.ios) ion-toolbar {
  --border-width: 0 !important;
}
:host-context(.ios) ion-toolbar.search-bar {
  padding-top: 0 !important;
}
ion-item.reset-item {
  --min-height: 3em;
}
ion-label {
  white-space: normal !important;
}
ion-radio {
  --color-checked: var(--ion-text-color);
}
/*# sourceMappingURL=category-select-modal.css.map */
